module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "entBox"
  }, [_c('el-form', {
    ref: "entform",
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules,
      "label-width": "130px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "企业全称",
      "prop": "name"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.name),
      callback: function($$v) {
        _vm.$set(_vm.form, "name", $$v)
      },
      expression: "form.name"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("*需与当地政府颁发的商业许可证书或企业注册证上的企业名称完全一致")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "统一社会信用代码"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": ""
    },
    model: {
      value: (_vm.form.code),
      callback: function($$v) {
        _vm.$set(_vm.form, "code", $$v)
      },
      expression: "form.code"
    }
  }), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("*请输入15位营业执照注册号或18位的统一社会信用代码")])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "营业执照",
      "prop": "previewImg"
    }
  }, [_c('viewer', {
    staticClass: "seeBigImg",
    attrs: {
      "images": _vm.fileList
    }
  }, _vm._l((_vm.fileList), function(img, index) {
    return _c('div', {
      staticClass: "imglists",
      staticStyle: {
        "position": "relative"
      }
    }, [_c('img', {
      key: index,
      attrs: {
        "src": img.url
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "delete"
    }, [_c('i', {
      staticClass: "el-icon-delete2",
      on: {
        "click": function($event) {
          _vm.handleRemove(img)
        }
      }
    })])])
  })), _vm._v(" "), _c('el-upload', {
    staticClass: "upload-box",
    attrs: {
      "action": ("/api/basic/img/upload?AccessToken=" + (_vm.getSession())),
      "headers": _vm.headers,
      "file-list": _vm.fileList,
      "list-type": "picture-card",
      "on-preview": _vm.handlePictureCardPreview,
      "on-success": _vm.handleAvatarSuccess,
      "on-remove": _vm.handleRemove,
      "accept": ".png,.jpg"
    }
  }, [_c('i', {
    staticClass: "el-icon-plus"
  })]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "size": "tiny"
    },
    model: {
      value: (_vm.previewImg),
      callback: function($$v) {
        _vm.previewImg = $$v
      },
      expression: "previewImg"
    }
  }, [_c('img', {
    attrs: {
      "width": "100%",
      "src": _vm.imageSrc,
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "12px"
    }
  }, [_vm._v("*上传扫描文件,支持PNG/JPG图片格式；如果上传后无反应，请更换谷歌浏览器后再尝试  "), _c('a', {
    attrs: {
      "target": "_blank",
      "href": "https://pc.qq.com/detail/1/detail_2661.html"
    }
  }, [_vm._v("下载谷歌浏览器")])])], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "行业"
    }
  }, [_c('el-cascader', {
    staticStyle: {
      "width": "400px"
    },
    attrs: {
      "placeholder": "请参考营业执照填写",
      "change-on-select": "",
      "options": _vm.options,
      "props": _vm.defaultProp
    },
    on: {
      "change": _vm.handleChange
    },
    model: {
      value: (_vm.selectedOption),
      callback: function($$v) {
        _vm.selectedOption = $$v
      },
      expression: "selectedOption"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "企业法人"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.form.legalPerson),
      callback: function($$v) {
        _vm.$set(_vm.form, "legalPerson", $$v)
      },
      expression: "form.legalPerson"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "联系电话"
    }
  }, [_c('el-input', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "placeholder": "手机号码"
    },
    model: {
      value: (_vm.form.phone),
      callback: function($$v) {
        _vm.$set(_vm.form, "phone", $$v)
      },
      expression: "form.phone"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "注册地址",
      "prop": "address"
    }
  }, [_c('dataTree', {
    attrs: {
      "defaultData": _vm.defaultPointerData
    },
    on: {
      "change": _vm.changeId
    }
  }), _vm._v(" "), _c('el-input', {
    staticStyle: {
      "width": "400px",
      "display": "block",
      "margin-top": "22px"
    },
    attrs: {
      "placeholder": "街道详细地址"
    },
    model: {
      value: (_vm.form.address),
      callback: function($$v) {
        _vm.$set(_vm.form, "address", $$v)
      },
      expression: "form.address"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "中心坐标",
      "prop": "latitude"
    }
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showMap.state = true
      }
    }
  }, [_vm._v("地图选点")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "5px"
    }
  }, [_vm._v("东经：" + _vm._s(_vm._f("formatDegree")(_vm.form.longitude)) + "，北纬：" + _vm._s(_vm._f("formatDegree")(_vm.form.latitude)))]), _vm._v(" "), _c('mapPointer', {
    attrs: {
      "show": _vm.showMap,
      "source": {
        lat: _vm.form.latitude,
        lng: _vm.form.longitude
      }
    },
    on: {
      "change": _vm.confirm
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "所属区划"
    }
  }, [_c('scaleRegion', {
    ref: "scaleRegiondata",
    attrs: {
      "isUpdata": _vm.isUpdata,
      "defaultObj": _vm.defaultObj
    },
    on: {
      "change": _vm.changeRegion,
      "changeIdval": _vm.changeRegionId
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e8921e9","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/plan/Entform.vue
// module id = 1245
// module chunks = 2